import React, { Fragment } from "react";
import "./style.css";
import Drugs from "components/tools/drugs";
import Radical from "components/tools/radical";
import Vector from "components/tools/vector";
import ToolsImage from "components/tools/tools";

const tools = [
  {
    name: "Drugs that overcome resistance",
    image: <Drugs />,
  },
  {
    name: "Bed nets, vaccines and other prevention methods",
    image: <Vector />,
  },
  {
    name: "Single-dose treatments",
    image: <Radical />,
  },
  {
    name: "Smart data and analytics",
    image: <ToolsImage />,
  },
];

const Tools = () => (
  <div className="tools">
    {tools.map(({ name, image }) => (
      <div className="tools__tool">
        <div className="tools__image">{image}</div>
        <h2 className="tools__title">
          {name.split(" ").map((word, i) => (
            <Fragment>
              <span>{word}</span>
              {i !== name.split(" ").length - 1 ? " " : ""}
            </Fragment>
          ))}
        </h2>
      </div>
    ))}
  </div>
);

export default Tools;



// WEBPACK FOOTER //
// ./src/components/tools/index.js